<div class="popup-overlay" (click)="closePopup()"></div>
<div class="popup-container">
  <div class="popup-header">
    <h3>Select Date Range</h3>
    <button class="close-icon" (click)="closePopup()">&#10005;</button>
  </div>
  <div class="popup-body">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>By Date Range</mat-label>

      <mat-date-range-input [rangePicker]="picker"
                            [formGroup]="dateRangeForm"
                            [max]="maxDate" 
                            (focus)="picker.open()"
                            (click)="picker.open()">
        <input matStartDate placeholder="Start date" formControlName="start" readonly />
        <input matEndDate placeholder="End date" formControlName="end" readonly />
      </mat-date-range-input>

      <!-- Dynamic icon: calendar or clear (×) -->
      <button mat-icon-button
        matSuffix
        [ngStyle]="{
          'z-index': 1000,
          'position': 'relative',
          'background': 'none',
          'border': 'none',
          'box-shadow': 'none',
          'outline': 'none'
        }"
        (click)="picker.open()"
        aria-label="Toggle date">

        <!-- Show normal calendar icon if no filter applied -->
        <mat-icon>calendar_today</mat-icon>
      </button>

      <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
    </mat-form-field>
  </div>
  <div class="popup-footer">
    <button (click)="applyDateRange()">Apply</button>
  </div>
</div>
